<template>
  <v-dialog 
    v-on:update:modelValue="updateDisplayDialog"
    max-width="850px"
    :model-value="displayDialog" 
  >
    <v-card
      class="d-flex flex-column align-content-space-around"
    >
      <v-card-title class="d-flex justify-content-center">
        <h2
          class="text-wrap text-center"
          v-html="$t('detail_page.about_movie', {title: assetData.title})"
        ></h2>
        <v-btn
          :ripple="false"
          icon="mdi-close"
          variant="plain"
          @click="updateDisplayDialog"
          class="close-dialog"
        ></v-btn>
      </v-card-title>
      <v-card-text class="">
                  
        <v-img
          class="poster-image"
          type="horizontal"
          :src="screenshot"
          :title="assetData.title"
          :alt="assetData.title"
          rounded="rounded-lg"
          aspect-ratio="1.77"
          width="100%"
        />

        <p class="synopsis">
          {{ useLegacyAsset ? assetData['description'] : assetData['synopsis'] }}
        </p>

        <p v-if="genres.length > 0">
          <strong>
            {{ $t('detail_page.details.genres') }}
          </strong>
          {{ genres }}
        </p>
        
        <p v-if="assetData['tv_rating']?.length > 0">
          <strong>
            {{ $t('detail_page.details.tv_rating') }}
          </strong>
          {{ assetData['tv_rating'] }}
        </p>

        <p v-if="assetData['country'].length > 0">
          <strong>
            {{ $t('detail_page.details.country') }}
          </strong>
          {{ assetData['country'] }}
        </p>

        <p v-if="directors.length > 0">
          <strong>
            {{ $t('detail_page.details.director') }}
          </strong>
          {{ directors }}
        </p>


        <p v-if="actors.length > 0">
          <strong>
            {{ $t('detail_page.details.cast') }}
          </strong>
          {{ actors }}
        </p>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import { GenresStore } from "@/stores/genresStore";
import { mapState } from "pinia";
import { ActorStore } from "../../stores/actorStore";
import { DirectorStore } from "../../stores/directorStore";

export default {
  name: "MovieDescriptionDialog",
  props: {
    assetData: Object,
    displayDialog: Boolean,
    useLegacyAsset: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateDisplayDialog(){
      this.$emit("toggleDisplayDialog");
    }
  },
  computed: {
    ...mapState(GenresStore, ["getGenre"]),
    ...mapState(ActorStore, ["getActorById"]),
    ...mapState(DirectorStore, ["getDirectorById"]),
    genres() {
      if(this.useLegacyAsset){
        return this.assetData.genres.join(", ");
      }

      return this.assetData.genres.map((genre) => {
        return this.getGenre(genre);
      }).join(", ");
    },  
    actors() {
      if(this.useLegacyAsset){
        return this.assetData.actors
          .map((actor) => actor.name)
          .join(", ");
      }

      return this.assetData.actors
        .map((actor) => this.getActorById(actor))
        .join(", ");
    },
    directors() {
      if(this.useLegacyAsset){
        return this.assetData.directors
          .map((director) => director.name)
          .join(", ");
      }

      return this.assetData.director
        .map((director) => this.getDirectorById(director))
        .join(", ");
    },
    screenshot() {
      if(this.useLegacyAsset){
        return this.assetData['screenshot'].original;
      }
      return this.assetData['screenshot'];
    }
  }
};
</script>


<style lang="scss" scoped>
.no-hover:hover :deep(.v-btn__overlay) {
  background-color: transparent;
  text-decoration: none !important;
  opacity: 1;
}
:deep(.v-card) {
  box-shadow: none;
  border: transparent none;
  box-sizing: unset;
}
.v-dialog > .v-overlay__content {
  max-width: 500px !important;
  .v-card {
    background: url("@/assets/img/plans/plan-upgrade-popup-bg.svg") no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 32px;
    .v-card-title{
      position: relative;
      padding: 2em 0;
      h2{
        font-size: 1.5rem;
      }
      .close-dialog {
        position: absolute;
        left: 1em;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .v-card-text{
      p{
        margin-top: 1em;
        font-size: 1.2rem;
        font-weight: 400;
      }
      .poster-image{
        margin-bottom: 2em;
        margin-left: 1em;
        margin-right: 1em;
        border-radius: 20px;
      }
      padding: 2em 4em;
    }
    .v-card-subtitle {
      margin-top: 16px;
      p {
        width: 320px;
        height: 48px;
        white-space: break-spaces;
        text-align: center;
      }
    }
    .v-card-actions > .v-btn {
      font-size: 16px;
      text-transform: none;
      width: 377px;
      @media (max-width: 480px) {
        width: 302px;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
}

</style>